import { render, staticRenderFns } from "./addArchive.vue?vue&type=template&id=ff938f60&"
import script from "./addArchive.vue?vue&type=script&lang=js&"
export * from "./addArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports